import moment from "moment";

// Règles de validations des champs de formulaires formulaires
export default {
  // Langue gloable pour les rules
  lang: "fr",

  obligatoire(){ 
    return (value) =>
      !!value ||
      (this.lang == "en" ? "Required field" : "Champ obligatoire");
  },

  arrayObligatoire(){ 
    return     (v) =>
      (v && v.length > 0) ||
      (this.lang == "en" ? "Required field" : "Champ obligatoire");
  },

  checkboxObligatoire(){
    return (v) => v === true ||
    (this.lang == "en" ? "You must check this box" : "Vous devez cocher cette case");
  },

  obligatoireWithZero(){
    return (v) =>
      (v !== null && v !== undefined && v !== "") ||
      v === 0 ||
      (this.lang == "en" ? "Required field" : "Champ obligatoire");
  },

  entier(){
    return (v) =>
      !v || /^-?\d+$/.test(String(v).trim()) ||
      (this.lang == "en" ? "Must be an integer" : "Doit être un entier");
  },

  obligatoiresField(otherField) {
    // Si le champ principal est vide et le champ supplémentaire est vide, retournez une erreur
    return (v) => 
      (v !== null && v !== undefined && v !== "") ||
      (otherField !== null && otherField !== undefined && otherField !== "") ||
        (this.lang == "en"
          ? "Required field"
          : "Ce champ est obligatoire");
  },

  email(){
    return (v) =>
      !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) ||
      (this.lang == "en" ? "Invalid email" : "Format email incorrect");
  },

  telephone(){
    return (v) =>
      !v || /^(\+\d{1,4}\s?)?(\d{1,}[\s.-]?){8,}$/.test(v) ||
      (this.lang == "en"
        ? "Invalid phone number"
        : "Format de téléphone incorrect");
  },

  alphaNumerique(){
    return (v) =>
      !v || /^[a-zA-Z0-9]+$/.test(v) ||
      (this.lang == "en" ? "Incorrect format" : "Format incorrect");
  },
  codeMassarFormat() {
    return (v) => {
      const messageEn = "Format must be 1 letter followed by 9 digits";
      const messageFr = "Le format doit être une lettre suivie de 9 chiffres";
      if (!v) {
        return this.lang === "en" ? messageEn : messageFr;
      }
      const isValid = /^[A-Za-z][0-9]{9}$/.test(v);
      return isValid || (this.lang === "en"
        ? messageEn
        : messageFr);
    };
  },
  latin(){
    return (v) =>
      !v || /^[a-zA-Z0-9áàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ _-\s.@'!]+$/.test(v) ||
      (this.lang == "en" ? "Please use only Latin letters" : "Veuillez utiliser uniquement des lettres latines");
  },
  
  cni(){
    return (v) =>
      !v || /^[a-zA-Z0-9_.-]*$/.test(v) ||
      (this.lang == "en"
        ? "Allowed characters"
        : "Caractères autorisés : a-z A-Z 0-9 _ - . ");
      },

  Equal(vCompare) {
    return (v) =>
      (v && vCompare && v.toLowerCase() === vCompare.toLowerCase()) ||
      (this.lang == "en"
        ? "Massar Code not match"
        : "Code Massar non correspondant");
  },
  EqualMail(vCompare) {
    return (v) =>
      (v && vCompare && v.toLowerCase() === vCompare.toLowerCase()) ||
      (this.lang == "en"
        ? "Email dont match"
        : "Email non correspondant");
  },
  EqualNumCni(vCompare) {
    return (v) =>
      (v && vCompare && v.toLowerCase() === vCompare.toLowerCase()) ||
      (this.lang == "en"
        ? "CNI dont match"
        : "CNI non correspondant");
  },
  LengthDix(){
     return v => !v || v.length < 10 || 
         (this.lang == "en" ? "9 characters maximum" : "9 caractères maximum");
  },

  loanMin(max) {
    return (v) => {
      if(v)
      {
          // Remplacer les ',' par '.'
          v = v.replace(',','.')

           const montantPattern = /^-?\d+(\.\d+)?(,\d+)?$/;
          if (!montantPattern.test(v)) {
              this.lang == "en" ? "Invalid value" : "Note invalide";
          }

          const montantNumerique = parseFloat(v);
          if (isNaN(montantNumerique) || montantNumerique < 0) {
            return this.lang == "en"
            ? "Invalid value"
            : "La note ne peut pas être inférieur à zéro";
          }
          if ((parseFloat(v) || "") > parseFloat(max)) {
            return this.lang == "en"
            ? "Invalid value"
            : `La note ne doit pas dépasser votre barem :${max}`;
          }
      }
      return true;
    };
  },

  Adresse(){
    return (v) =>
      !v || /^[a-zA-Z0-9áàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ _-\s.,@'!]+$/.test(v) ||
      (this.lang == "en" ? "Please use only Latin letters" : "Veuillez utiliser uniquement des lettres latines");
  },
  
  EstNumerique(){
    return (v) => !v || !isNaN(v.toString().replace(",",".")) || 'Veuillez renseigner un numérique'
  },

  EstDate(){
    return (v) =>
      !v || moment(`${v.split("/")[2]}-${v.split("/")[1]}-${v.split("/")[0]}`, "YYYY-MM-DD", true).isValid() ||
      (this.lang == "en" ? "Invalid date format (DD/MM/YYYY)" : "Format de date invalide (JJ/MM/AAAA)");
  },
};
